import type { ReactNode } from "react";

/**
 * A table that scrolls inside its own box rather than spilling out of it.
 *
 * On a narrow screen the radar's last column — the one carrying the money —
 * was simply clipped, because the wrapper had `overflow-x: visible` and
 * nothing to scroll. Every data table has the same shape and the same
 * problem, so the fix lives here rather than being remembered seven times.
 */
export function Scrolls({ children }: { children: ReactNode }) {
  return <div className="tablewrap">{children}</div>;
}
